'use client';
import { Loading } from '@/shared/components/parts/Loading';
import { Spacer } from '@/shared/components/parts/Spacer';
import { MenuTabs } from '../../_components/MenuTabs';
import { AdultGenreCheck } from './AdultGenreCheck';
import { UsageEvent } from './UsageEvent';
import { usePointHistoryUsage } from './index.hook';

export const PointHistoryUsage: React.FC = () => {
  const { state, showAdultContent, maskAdultContent } = usePointHistoryUsage();

  return (
    <div className="cst-side-space mx-auto max-w-180">
      <MenuTabs />
      {state.pageStatus === 'INIT' && <Loading />}
      {state.pageStatus === 'PREPARED' && (
        <div>
          {state.historyList.length > 0 && (
            <div>
              <Spacer spacing={4} />
              <AdultGenreCheck
                canBeShownAdultContent={state.canBeShownAdultContent}
                showAdultContent={showAdultContent}
                maskAdultContent={maskAdultContent}
              />
            </div>
          )}
          <Spacer spacing={8} />
          <div>
            <div className="grid grid-cols-1 gap-8">
              {state.historyList.length > 0 ? (
                state.historyList.map(([key, value]) => (
                  <div key={key} className="rounded-3 bg-base-100">
                    <div className="p-4 text-base1 font-bold cst-halt leading-[1.4] text-main-100">
                      {key}
                    </div>
                    {value.map((data, index) => (
                      <div
                        key={`${key}${index}`}
                        className="border-t border-t-main-10 p-4"
                      >
                        <UsageEvent
                          data={data}
                          canBeShownAdultContent={state.canBeShownAdultContent}
                        />
                      </div>
                    ))}
                  </div>
                ))
              ) : (
                <div className="rounded-3 bg-base-100">
                  <div className="py-8 text-center">
                    180日以内の履歴がありません。
                  </div>
                </div>
              )}
            </div>
            <Spacer spacing={8} />
            <div className="text-base3 text-main-40">
              ※U-NEXTポイントには有効期限があります。有効期限は付与条件により異なります。
              <br />
              ※U-NEXTポイントは、メイン・サブアカウントで共有のポイントとなります。
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
